<script>
    import { onMount, setContext } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import { useRefresh } from "@kestrel/stores";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import { renderAlternativeRecommendationsInternal } from "../services/nexusInternal/internalNexusEvents.js";
    import { getAggregationFeatureLabels, getFeatureOrder } from "../utils/externalTrackingHelper.js";
    import { key as cinemaDimensionsDisplayCtxKey } from "../context/dimensionsDisplay.js";

    let { data } = $props();

    let additionalTrackingLabels = $state(null);
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let trackingEventMergeId = $state(null);
    let refreshingKey = $state("");
    let refreshingDomClass = $state("");
    let loadedTrackingActionName = $state("change");
    const [cinemaContainerMounted, mountSuccess] = withResolvers();
    let cinemaContainer;

    const reloadAlternativesData = useRefresh();

    setContext(cinemaDimensionsDisplayCtxKey, () => data?.dimensionsDisplay);

    const reloadAlternatives = async (applyShoeSizeFilter) => {
        refreshingDomClass = "__loading";
        const newUrl = `/alternative?variationId=${data.variationId}&applyShoeSizeFilter=${applyShoeSizeFilter}`;

        await reloadAlternativesData(newUrl);
        refreshingDomClass = "";
    };

    const removeShoeSizeFilterHandler = async () => {
        loadedTrackingActionName = "deselect";
        await reloadAlternatives(false);
        refreshingKey = "filterRemoved";
    };

    onMount(() => {
        featureIndex = getFeatureOrder(cinemaContainer);
        additionalTrackingLabels = getAggregationFeatureLabels(cinemaContainer);
        cinemaInjectionContainerWidth = cinemaContainer.offsetWidth || 1000;

        return renderAlternativeRecommendationsInternal.sub(
            (detail) => {
                if (!detail?.variationId) {
                    return;
                }
                trackingEventMergeId = detail?.eventMergeId;
                mountSuccess();
            },
            { once: true }
        );
    });
</script>

<div bind:this={cinemaContainer}>
    {#if data}
        <div
            class="reco_alternative_cinema_wrapper{refreshingDomClass}"
            class:reco_alternative_cinema_comparison_eligible={data.pbkIsPartOfComparisonOnEx || false}
        >
            {#key refreshingKey}
                <Cinema
                    headline={data.headline}
                    subHeadline={data.subHeadline}
                    recommendations={data.recommendations}
                    tracking={data.tracking}
                    {featureIndex}
                    additionalClickTracking={data.additionalClickTracking}
                    featuresState={data.featuresState}
                    {cinemaInjectionContainerWidth}
                    cinemaMeta={data.metaData}
                    {trackingEventMergeId}
                    {loadedTrackingActionName}
                    showTopInfo={true}
                    personalisedUser={data.hasPersonalisedRecommendations || false}
                    removeShoeSizeFilterCallback={removeShoeSizeFilterHandler}
                    {additionalTrackingLabels}
                    {cinemaContainerMounted}
                />
            {/key}
        </div>
    {/if}
</div>

<style lang="scss">
    .reco_alternative_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;

        &__loading {
            pointer-events: none;
            opacity: 0.5;
        }
    }
</style>
